/* Gift Mart: LastHour mobile badge suppression. Desktop is untouched. */
(function () {
  'use strict';
  function isMobile() { return window.matchMedia && window.matchMedia('(max-width: 749px)').matches; }
  function hideLastHourBadge() {
    if (!isMobile()) return;
    var elements = document.querySelectorAll('body *');
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if (!el || !el.textContent) continue;
      var text = el.textContent.replace(/\\s+/g, ' ').trim().toLowerCase();
      if (text.indexOf('people are viewing this store') === -1) continue;
      var target = el;
      for (var level = 0; level < 5 && target && target !== document.body; level++) {
        var rect = target.getBoundingClientRect ? target.getBoundingClientRect() : null;
        var style = window.getComputedStyle(target);
        if ((style.position === 'fixed' || style.position === 'absolute' || style.position === 'sticky') && rect && rect.width > 150 && rect.height > 30) break;
        target = target.parentElement;
      }
      if (target && target !== document.body) {
        target.style.setProperty('display', 'none', 'important');
        target.style.setProperty('visibility', 'hidden', 'important');
        target.style.setProperty('pointer-events', 'none', 'important');
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideLastHourBadge, { once: true });
  else hideLastHourBadge();
  var observer = new MutationObserver(hideLastHourBadge);
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  window.addEventListener('resize', hideLastHourBadge, { passive: true });
})();
